import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  DateField,
  List,
  TextField,
  EditButton,
  TextInput,
  ShowButton,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="code" alwaysOn />,
  <TextInput label="Short Description" source="short_description" />,
];

export const CatalogSamplesList = withStyles(styles)(
  ({ classes, ...props }) => (
    <List
      {...props}
      filters={filters}
      actions={<MyListActions />}
      sort={{ field: "code", order: "ASC" }}
      pagination={<MyListPagination />}
      perPage={25}
    >
      <Datagrid>
        <TextField source="code" />
        <TextField source="short_description" />
        <DateField
          source="createdAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        <DateField
          source="updatedAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        <EditButton />
        <ShowButton />
      </Datagrid>
    </List>
  )
);
